<template>
  <div :style="{ backgroundImage: 'url(' + bgImage + ')' }" id="div-bg">
    <v-card class="mx-auto fs-card-device" width="700px" elevation="20">
      <v-row no-gutters>
        <v-col>
          <div id="div-card-image" class="pt-12">
            <v-img class="fs-img-auth" :src="cadeado"/>
            <div class="mt-5" style="text-align: center; color: white">
              Identifique o dispositivo:
              <v-form autocomplete="off">
                <v-text-field
                  id="dispositivo"
                  v-model="dispositivo"
                  class="pt-2 px-12 fs-descricao"
                  style="font-size: 12px"
                  spellcheck="false"
                  @keyup.enter="formSubmitSolicitar()"
                  placeholder=" "
                  hide-details
                  autofocus
                  dense
                  solo
                />
                <div class="text-left pl-12">
                  <br><span style="line-height:16px; color: white; font-size: 11px; margin-left: 12px;">Exemplos:</span>
                  <br><span style="line-height:16px; color: white; font-size: 11px; margin-left: 12px;">- <strong>COMPUTADOR DA SALA 01</strong></span>
                  <br><span style="line-height:16px; color: white; font-size: 11px; margin-left: 12px;">- <strong>NOTEBOOK DO JUNIOR</strong></span>
                  <br><span style="line-height:16px; color: white; font-size: 11px; margin-left: 12px;">- <strong>CELULAR DA MARIA</strong></span>
                </div>
                <v-btn class="mt-9" @click="formSubmitSolicitar()" :disabled="desabilitarBtns" color="success">
                  <v-icon class="mr-2">mdi-email-outline</v-icon>
                  Solicitar Chave de Liberação
                </v-btn>
              </v-form>
            </div>
          </div>
        </v-col>
        <v-col>
          <v-img class="fs-logotipo-login" :src="logo"/>
          <v-form autocomplete="off" class="ma-5 px-3" style="text-align: center">
            <span style="font-size: 14px; font-weight: 300; letter-spacing: .5px">Dispositivo <b>Desconhecido</b></span>
            <v-text-field
              class="mt-8"
              height="37px"
              type="text"
              id="chave"
              v-model="chave"
              @keyup.enter="formSubmit()"
              label="Chave de Liberação"
              placeholder="Digite aqui a chave enviada por e-mail."
              style="font-size: 13px"
              spellcheck="false"
              outlined
              dense
            />
            <v-btn block @click="formSubmit()" :disabled="desabilitarBtns" class="mt-n2" color="primary">
              Liberar Dispositivo
            </v-btn>
          </v-form>
          <div class="mt-4 mx-8 text-justify" style="line-height: 18px;">
            Este sistema controla e mapeia todos os dispositivos, ou seja, os computadores e celulares que o
            acessam. <strong>O acesso só é permitido após a digitação da CHAVE DE LIBERAÇÃO</strong> enviada para o
            email do <strong>ADMINISTRADOR</strong> do sistema.
          </div>
          <div class="mt-4 mb-10 text-center">
            <router-link to="signIn" tag="a" class="text-muted ">
              <u>Voltar para o Login</u>
            </router-link>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import * as deviceAPI from '@/api/device'

export default {
  metaInfo: {
    title: 'Dispositivo Desconhecido'
  },
  data () {
    return {
      retorno: '',
      dispositivo: '',
      chave: '',
      desabilitarBtns: false,
      bgImage: require('@/assets/images/map1.jpg'),
      logo: require('@/assets/images/logo.png'),
      cadeado: require('@/assets/images/cadeado.png')
    }
  },
  computed: {
    ...mapGetters('device', ['getDevice', 'getEmailRetorno']),
    ...mapGetters('authData', ['loggedInUser'])
  },
  watch: {
    getEmailRetorno () {
      this.retorno = this.getEmailRetorno.msg
    }
  },
  mounted () {
    if (!this.loggedInUser || !this.getDevice.fingerprint) this.$router.push('/app/sessions/signIn')
  },
  methods: {
    ...mapActions('device', ['editDevice', 'findDevice', 'enviarEmailNovoDispositivo']),
    ...mapMutations('global', ['setSnackbar']),
    async formSubmitSolicitar () {
      this.dispositivo = this.dispositivo.toUpperCase()
      this.desabilitarBtns = true
      if (this.dispositivo === '') {
        this.setSnackbar({ msg: 'Digite a identificação para este dispositivo!', color: 'error' })
      } else {
        const device = Object.assign({}, this.getDevice)
        device.device = this.dispositivo
        await this.editDevice(device)
        const deviceEmail = Object.assign({}, device)
        deviceEmail.email = process.env.VUE_APP_EMAIL_ADMINISTRADOR
        deviceEmail.usuario = this.loggedInUser.nome
        await this.enviarEmailNovoDispositivo(deviceEmail)
        this.setSnackbar({ msg: 'Chave enviada para o email: ' + deviceEmail.email, color: 'warning' })
      }
      this.desabilitarBtns = false
    },
    async formSubmit () {
      this.desabilitarBtns = true
      if (this.chave === '') {
        this.setSnackbar({ msg: 'Digite a Chave, ela é obrigatória!', color: 'error' })
        this.desabilitarBtns = false
      } else {
        try {
          await deviceAPI.validaChaveLiberacao({ chave: this.chave, fingerprint: this.getDevice.fingerprint })
          window.localStorage.setItem('fingerprint', this.getDevice.fingerprint)
          window.localStorage.setItem('fingerprint_data', new Date()) // Salva a data para controlar o vecimento do fingerprint
          this.setSnackbar({ msg: 'Chave validada com sucesso, redirecionando...', color: 'success', timeout: 2500 })
          const deviceResult = await this.findDevice(this.getDevice.fingerprint)
          const Obj = Object.assign({}, deviceResult)
          Obj.liberado = 'S'
          // Atualiza o dispositivo para liberado
          await this.editDevice(Obj)
          setTimeout(() => {
            this.desabilitarBtns = false
            this.$router.push('/')
          }, 2500)
        } catch (error) {
          this.setSnackbar({ msg: 'Chave inválida!', color: 'error' })
          this.desabilitarBtns = false
        }
      }
    }
  }
}
</script>

<style scoped>
  #div-bg {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    height: 100vh;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  #div-card-image {
    width: 350px;
    height: 100%;
    border-top-left-radius: 13px;
    border-bottom-left-radius: 13px;
    background-color: #2A2F50 !important;
  }
  .fs-logotipo-login {
    width: 100px !important;
    margin-top: 30px;
    margin-left: 122px;
  }
  .fs-img-auth {
    margin-top: 25px;
    width: 90px !important;
    margin-left: 130px;
  }
  .fs-device-desc {
    text-align:center;
    margin-top: 80px;
    margin-bottom: -10px;
    font-size: 10px;
    padding-left: 5px;
    padding-right: 5px;
    font-weight: 300;
    letter-spacing: .4px;
    color: black;
  }
  .fs-card-device {
    border-radius: 13px !important;
    border-top-left-radius: 16px !important;
    border-bottom-left-radius: 16px !important;
  }
  strong {
    font-weight: 500;
    letter-spacing: .6px;
  }
</style>
